import { useSelector } from 'react-redux';

// Step 30: one place that turns the redux client store into a plain list,
// so column 1 (the CLIENT chooser) and column 3 (ADD MORE CLIENTS) read the
// same clients. The store is { userId: '<uid>', '<uid>': { <client_id>:
// client, ... } }; deleted clients are left out. Same derivation as
// column 1 has used since Step 28.
export function clientListFromStore(clientsStore) {
  if (!clientsStore || typeof clientsStore !== 'object') return [];
  return Object.entries(clientsStore)
    .filter(([key, group]) => key !== 'userId' && group && typeof group === 'object')
    .flatMap(([, group]) =>
      Object.entries(group)
        .filter(([, client]) => client && typeof client === 'object' && !client.is_delete)
        .map(([client_id, client]) => ({ ...client, client_id }))
    );
}

export default function useClientList() {
  const clientsStore = useSelector((state) => state.clients);
  return clientListFromStore(clientsStore);
}
